import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';

import { CoreModule } from '@app/core/core.module';
import { MainRoutingModule } from '@app/main/main-routing.module';
import { MainServicesModule } from '@app/main/services/main-services.module';
import { CookieBannerModule } from '@global/cookie-banner/cookie-banner.module';
import { ServiceWorkerModule } from '@angular/service-worker';

import { MainContainerComponent } from './containers/main-container.component';
import { SessionWarningModalComponent } from '@global/shared-features/modals/session-warning-modal/session-warning-modal.component';

import { SessionService } from '@global/services/session/session.service';

import { environment } from '@env/environment';
import { metaReducers } from '@app/main/state/reducers';
import { IndexSvgComponent } from '@global/shared-features/index-svg/index-svg.component';

@NgModule({
  declarations: [MainContainerComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    MainRoutingModule,
    MainServicesModule,
    CookieBannerModule,
    StoreModule.forRoot(
      {},
      {
        metaReducers,
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
        },
      }
    ),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot(),
    ServiceWorkerModule.register('./sw.js', {
      enabled: environment.production,
    }),
  ],
  providers: [SessionService],
  bootstrap: [MainContainerComponent, IndexSvgComponent],
  entryComponents: [SessionWarningModalComponent],
})
export class MainModule {}
